import { types } from "../graphql";

enum Action {
  READ,
  WRITE,
}

enum AuthorizationLevel {
  PUBLIC = 0,
  ANONYMOUS = 1,
  AUTHENTICATED = 2,
  AUTHORIZED = 3,
}

function checkAuthorization(
  participant: types.Participant | null | undefined,
  block: types.Block,
  action: Action,
) {
  let authorizationLevel: AuthorizationLevel =
    action === Action.WRITE
      ? block.writeAccessLevel ?? block.accessLevel
      : block.accessLevel;

  switch (authorizationLevel) {
    case AuthorizationLevel.PUBLIC:
      return true;
    case AuthorizationLevel.ANONYMOUS:
      return !!participant;
    case AuthorizationLevel.AUTHENTICATED:
      return participant?.authenticated ?? false;
    case AuthorizationLevel.AUTHORIZED:
      return (
        participant?.groups?.length &&
        block.groups?.length &&
        block.groups.some(
          (block_group) =>
            participant.groups?.some(
              (participant_group: string) => block_group === participant_group,
            ),
        )
      );
  }
}

export { checkAuthorization, Action, AuthorizationLevel };
